import { Hammer, Phone, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { COMPANY, scrollToId } from "@/lib/site";

const LINKS = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
    { id: "projects", label: "Projects" },
    { id: "faqs", label: "FAQs" },
    { id: "contact", label: "Contact" },
];

export default function Footer() {
    return (
        <footer data-testid="footer-section" className="bg-[#0D0D0D] noise-overlay relative text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-3">
                            <span className="w-10 h-10 rounded-xl bg-[#E85A1D] flex items-center justify-center">
                                <Hammer className="w-5 h-5 text-white" strokeWidth={2.2} />
                            </span>
                            <span className="leading-none">
                                <span className="font-display font-extrabold tracking-tight text-lg block">APPEX</span>
                                <span className="font-mono-brand text-[10px] uppercase tracking-[0.22em] text-white/50">
                                    Smart Solution
                                </span>
                            </span>
                        </div>
                        <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-sm">
                            Construction, Maintenance & Home Improvement. Professional, reliable services for
                            homeowners, landlords and property managers across Luton and surrounding areas.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {[
                                { Icon: Facebook, label: "Facebook (coming soon)" },
                                { Icon: Instagram, label: "Instagram (coming soon)" },
                                { Icon: Linkedin, label: "LinkedIn (coming soon)" },
                            ].map(({ Icon, label }) => (
                                <span
                                    key={label}
                                    title={label}
                                    aria-label={label}
                                    className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/40 cursor-not-allowed"
                                >
                                    <Icon className="w-4 h-4" />
                                </span>
                            ))}
                        </div>
                    </div>

                    <div>
                        <h3 className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[#E85A1D] font-semibold">
                            Quick Links
                        </h3>
                        <ul className="mt-5 space-y-3">
                            {LINKS.map((l) => (
                                <li key={l.id}>
                                    <button
                                        onClick={() => scrollToId(l.id)}
                                        className="text-sm text-white/60 hover:text-white transition-colors duration-200"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[#E85A1D] font-semibold">
                            Contact
                        </h3>
                        <div className="mt-5 space-y-4">
                            <p className="flex items-start gap-3 text-sm text-white/60">
                                <MapPin className="w-4 h-4 text-[#E85A1D] mt-0.5 shrink-0" />
                                17 Ames Close, Luton,
                                <br />
                                LU3 4AS, United Kingdom
                            </p>
                            <a
                                data-testid="footer-phone-link"
                                href={COMPANY.phoneHref}
                                className="flex items-center gap-3 text-sm font-bold text-white hover:text-[#E85A1D] transition-colors duration-200"
                            >
                                <Phone className="w-4 h-4 text-[#E85A1D]" />
                                {COMPANY.phoneDisplay}
                            </a>
                            <a
                                data-testid="footer-phone-link-2"
                                href={COMPANY.phone2Href}
                                className="flex items-center gap-3 text-sm font-bold text-white hover:text-[#E85A1D] transition-colors duration-200"
                            >
                                <Phone className="w-4 h-4 text-[#E85A1D]" />
                                {COMPANY.phone2Display}
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 py-7 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-white/40">
                        © {new Date().getFullYear()} Appex Smart Solution · Construction company & property maintenance in Luton
                    </p>
                    <a
                        href="https://www.wktechexpert.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-credit-link"
                        className="text-xs text-white/40 hover:text-[#E85A1D] transition-colors duration-200"
                    >
                        Created by www.wktechexpert.com
                    </a>
                </div>
            </div>
        </footer>
    );
}
